import React from 'react';

export default class DeviceConfig extends React.Component {
  render() {
    return <div>出厂信息</div>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/DeviceInfo/DeviceFactory.js